import { FIELD_WIDTH } from "@carbon/shared";

// @deprecated - Import FIELD_WIDTH from @carbon/shared instead
export const COLUMN = FIELD_WIDTH;
